import React from 'react';

interface StatsRowProps {
  label: string;
  overall: string | number;
  home: string | number;
  away: string | number;
  color?: string;
  onClick?: (location: 'overall' | 'home' | 'away') => void;
  isSelected?: boolean;
  selectedLocation?: 'overall' | 'home' | 'away' | null;
}

export const StatsTableRow: React.FC<StatsRowProps> = ({
  label,
  overall,
  home,
  away,
  color,
  onClick,
  isSelected,
  selectedLocation
}) => {
  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
        {label}
      </td>
      <td 
        className={`px-6 py-4 whitespace-nowrap text-sm ${color || 'text-gray-900'} ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''} ${isSelected && selectedLocation === 'overall' ? 'bg-gray-100' : ''}`}
        onClick={() => onClick && onClick('overall')}
      >
        {overall}
      </td>
      <td 
        className={`px-6 py-4 whitespace-nowrap text-sm ${color || 'text-gray-900'} ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''} ${isSelected && selectedLocation === 'home' ? 'bg-gray-100' : ''}`}
        onClick={() => onClick && onClick('home')}
      >
        {home}
      </td>
      <td 
        className={`px-6 py-4 whitespace-nowrap text-sm ${color || 'text-gray-900'} ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''} ${isSelected && selectedLocation === 'away' ? 'bg-gray-100' : ''}`}
        onClick={() => onClick && onClick('away')}
      >
        {away}
      </td>
    </tr>
  );
};